import { _ } from "~/i18n";
import Dialog from "~/ui/dialog";
import createSDSIcon from "~/ui/icon";
import { MYMAPS_CLOSE } from "~/ui/sds-compatible-icons";
import { node } from "~/util/dom";

export function createRouteClearButton() {
	const clear = node("button", { type: "button", className: "edit-props-btn" });

	clear.appendChild(createSDSIcon({ className: "edit-props-btn-icon-exit", symbol: MYMAPS_CLOSE }));
	clear.addEventListener("click", () => {
		const routeState = Mapy.CML.state.route;
		const closeCb = () => {
			Mapy.getComponent("route").clear({
				params: {
					...routeState.params,
					waypoints: "",
					departure: true,
					datetime: "",
					avoidHighways: false,
					allowViaFerrata: false,
				},
			});
			Mapy.getComponent("history").save();
		};

		if (routeState.likeDataChange) {
			const dialog = new Dialog({
				title: _("route.likeChangeClose.title"),
				desc: _("route.likeChangeClose.desc"),
				className: "route-close-dialog",
			});

			dialog.setBasic({
				closeTxt: _("close2"),
				bindEnter: true,
				cb: () => {
					closeCb();
				},
			});
			dialog.open();
		} else {
			closeCb();
		}
	});

	return clear;
}
